// extracted by mini-css-extract-plugin
export default {"pieContainer":"styles_pie-container__bYlqU","pieTitle":"styles_pie-title__+9+X4"};